import {AfterViewChecked, AfterViewInit, Component, ElementRef, OnInit, ViewChild, ChangeDetectorRef, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {DataService} from '../../../../Services/data.service';
import {AppConfigService} from '../../../../Services/app-config.service';
import {StorageService} from '../../../../Services/storage.service';
import {Title} from '@angular/platform-browser';
import {FilterPipe} from 'ngx-filter-pipe';
import {DataExportService} from '../../../../Services/dataExport.service';

import {DateFilterService} from '../../../../Services/dateFilter.service';
import {NotificationService} from '../../../../Services/notification.service';
import {UntypedFormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {EmailService} from '../../../../Services/email.service';
import {ResponseModel} from '../../../../DataModels/response-model';
import {EmailPassDataServiceService} from '../../../../Services/email-pass-data-service.service';
import {ActivatedRoute, Router} from '@angular/router';
import {EmailModel} from '../../../../DataModels/email-model';
import {Modal} from 'bootstrap';
import {SendEmailModalComponent} from '../../../common/send-email-modal/send-email-modal.component';
import {ReportPrintService} from '../../../../Services/report-print.service';

@Component({
  selector: 'app-trial-balance',
  templateUrl: './trial-balance.component.html',
  styleUrls: ['./trial-balance.component.css'],
  standalone: false
})
export class TrialBalanceComponent implements OnInit, AfterViewInit, AfterViewChecked {

  @ViewChild('EmailContent', {static: false}) EmailContent: ElementRef;
  @ViewChild('ExcelExport', {static: false}) ExcelExport: ElementRef;

  // Email modal integration
  reportDataToSendInEmail: EmailModel = new EmailModel();
  // Standard report header button configuration
  buttonConfig: any = {
    reportFormat: false,
    printReport: true,
    email: true,
    update: true,
    exportExcel: true,
    close: true,
  };
  @ViewChild(SendEmailModalComponent, {read: ElementRef}) private localSendEmailModalHost: ElementRef;

  private rptName: string;
  vm: any = {
    ToEmailError: false,
    showSpecificDates: false,
    company: [],
    currency: [],
    email: {
      toemail: null,
      fromemail: this.appConfigService.SysEmailAddress,
      PdfHtml: null,
      Subject: null,
    },
    request: {
      fromDate: null,
      toDate: null,
      company_id: '',
    },
    report: [],
    totalDebits: null,
    Preferences: [],
    permissions: [],
    netIncome: null,
    fromDateSelect: [],
    toDateSelect: [],
    monthCount: 0,
    totalCredits: null,
    dateError: false,
    buttonsDisabled: false,
    companyName: null,
    filtered: null,
    showEmail: true,
    exportToExcel: true,
    showFilters: false
  };

  constructor(public localStorage: StorageService,
              public tableDataService: DataService,
              private titleService: Title,
              public appConfigService: AppConfigService, public dateFilter: DateFilterService,
              public notification: NotificationService,
              private fb: UntypedFormBuilder,
              private router: Router,
              public route: ActivatedRoute,
              public aEmail: EmailService,
              public excelExporter: DataExportService,
              private cdr: ChangeDetectorRef,
              private reportPrint: ReportPrintService,
              private destroyRef: DestroyRef,
  ) {
    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));
    this.vm.email.toemail = this.localStorage.StorageGet('ToEmail', '');
  }

  ngOnInit() {
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      if (params.toDate !== undefined) {
        this.vm.request.toDate = params.toDate;
        this.vm.showSpecificDates = true;
      }
      if (params.fromDate !== undefined) {
        this.vm.request.fromDate = params.fromDate;
        this.vm.showSpecificDates = true;
      }

      if (!this.vm.request.toDate && !this.vm.request.fromDate) {
        this.newDateFilter(new Date(), new Date());
        this.primeLastNinetyDays();
      }

      this.newDateFilter(this.vm.request.toDate, this.vm.request.fromDate);
    });

    this.FilterOptionsInit();
    this.rptName = $localize`:Trial Balance Sheet Report @@trialBalanceSheetReport:Trial Balance Sheet Report`;
  }

  private primeLastNinetyDays() {
    const range = this.dateFilter.GetDefaultDateRange('span', this.vm.fromDateSelect, this.vm.toDateSelect);
    this.vm.request.toDate = range.toDate;
    this.vm.request.fromDate = range.fromDate;
  }

  ngAfterViewInit() {
    this.titleService.setTitle(this.rptName);
    // console.log('Time Out --> ' + this.timeOut);
  }

  newDateFilter(toDate, fromDate) {
    const ret = this.dateFilter.DateFilterInit(toDate, fromDate);
    this.vm.fromDateSelect = ret.fromDateSelect;
    this.vm.toDateSelect = ret.toDateSelect;
    this.vm.monthCount = ret.monthCount;
  }

  ngAfterViewChecked() {
    // Legacy email pass-through removed in favor of SendEmailModalComponent
  }

  FilterOptionsInit() {
    this.tableDataService.getData('company?state=active&pageNumber=0&pageSize=999999').subscribe((result: ResponseModel) => {
      this.vm.company = result.Data;
    });
    this.tableDataService.getData('currency?state=active&pageNumber=0&pageSize=999999').subscribe((result: ResponseModel) => {
      this.vm.currency = result.Data;
    });

  }

  setEmailData() {
    const emailDocObj = {} as EmailModel;
    const reportName = 'Trial Balance Report';

    // printing options
    emailDocObj.print_orientation = '1';
    emailDocObj.convert_attachment_to = 'pdf';

    emailDocObj.fromEmail = '';
    emailDocObj.fromName = 'AcctXErp';
    emailDocObj.header_id = '';
    emailDocObj.toEmail = '';
    emailDocObj.body = 'Please see the attached ' + reportName + '.<br><br><br>'
      + 'Best regards,'
      + '<br><br>'
      + 'AcctXErp'
      + '<br><br>';
    emailDocObj.Subject = 'AcctXErp ' + reportName;

    // Ensure latest DOM is rendered before capturing HTML
    try {
      this.cdr.detectChanges();
    } catch { /* noop */
    }

    // Use the same HTML as printing to ensure consistency
    try {
      emailDocObj.pdfHtml = this.buildPrintHtml(true);
    } catch {
      // Fallback to raw excel-export inner HTML if builder fails
      try {
        const html = this.ExcelExport?.nativeElement?.outerHTML
          || document.getElementById('excel-export')?.outerHTML
          || '';
        emailDocObj.pdfHtml = html;
      } catch {
        emailDocObj.pdfHtml = '';
      }
    }
    emailDocObj.activity_message = reportName;

    // deterministic file name
    const now = new Date();
    const yyyy = String(now.getFullYear());
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    emailDocObj.FileName = 'Trial_Balance_Report_' + yyyy + mm + dd + '.pdf';

    this.reportDataToSendInEmail = emailDocObj;

    const openModal = () => {
      const element = document.getElementById('sendEmailModal') as HTMLElement;
      if (element) {
        const emailModal = new Modal(element);
        emailModal.show();
      }
    };

    setTimeout(openModal, 0);
  }

  // Print the report content using a generated HTML document (do not use PrintService)
  printReport() {
    try {
      const html = this.buildPrintHtml();
      this.printHtmlInIframe(html);
    } catch (e) {
      console.error('Trial Balance print failed', e);
    }
  }

  // Build a self-contained HTML for printing/emailing the current report
  private buildPrintHtml(forEmail: boolean = false): string {
    const rawContent = (this.ExcelExport?.nativeElement?.outerHTML || document.getElementById('excel-export')?.outerHTML || '').toString();
    const content = this.reportPrint.cleanContentHtml(rawContent);
    const from = this.vm?.request?.fromDate || '';
    const to = this.vm?.request?.toDate || '';
    const meta: { label: string; value: string }[] = [];
    if (from || to) {
      meta.push({label: 'Period', value: `${from} to ${to}`});
    }
    return this.reportPrint.buildHtml({title: 'Trial Balance', contentHtml: content, meta, orientation: 'landscape'});
  }


  private printHtmlInIframe(html: string): void {
    this.reportPrint.printInIframe(html);
  }

  exportToExcel() {
    this.excelExporter.exportToExcel(this.ExcelExport, this.rptName + '.xlsx');
  }

  calcTotals() {
    this.vm.totalDebits = this.vm.totalCredits = this.vm.netIncome = 0;

    for (const [x, value] of Object.entries(this.vm.report)) {
      if ((this.vm.report[x].type_id == '4') || (this.vm.report[x].type_id == '5') || (this.vm.report[x].type_id == '6')) {
        this.vm.netIncome += Number(0 - this.vm.report[x].debit_credit);
      }
      if (this.vm.report[x].debit_credit > 0) {
        this.vm.totalDebits += Number(this.vm.report[x].debit_credit);
      } else {
        this.vm.totalCredits += Number(this.vm.report[x].debit_credit);
      }
    }
  }

  update() {
    const tempToDate: any = new Date(this.vm.request.toDate);
    const tempFromDate: any = new Date(this.vm.request.fromDate);
    if (tempFromDate > tempToDate) {
      this.vm.dateError = true;
      this.notification.warning($localize`:The To date must greater than the From date. @@theTodatemustgreaterthantheFromdate:The To date must greater than the From date.`);
    } else if (!this.vm.request.fromDate || !this.vm.request.toDate) {
      this.vm.dateError = true;
      this.notification.warning($localize`:You must select From and To dates. @@youmustselectFromandTodates:You must select From and To dates.`);
    } else {
      this.vm.request.toDate = this.dateFilter.GetDateFormat(this.vm.request.toDate);
      this.vm.request.fromDate = this.dateFilter.GetDateFormat(this.vm.request.fromDate);

      this.vm.monthCount = (tempToDate - tempFromDate) / 86400 / 30 / 1000;
      this.vm.buttonsDisabled = true;
      this.vm.dateError = false;
      let param = '';
      if (this.vm.request.company_id != null || this.vm.request.company_id != '') {
        param += '&company_id=' + this.vm.request.company_id;
      }
      this.tableDataService.getData('trial_balance', '?fromDate=' + this.vm.request.fromDate + '&toDate=' + this.vm.request.toDate + param)
        .subscribe((result) => {
          this.vm.report = result;
          if (this.vm.request.company_id) {
            this.vm.filtered = true;
            this.vm.companyName = this.FilterObject(this.vm.company, {id: this.vm.request.company_id})[0].name;
          } else {
            this.vm.companyName = '';
          }
          this.calcTotals();
          this.vm.buttonsDisabled = false;
          // this.localStorage.StorageSet('fromDate', this.vm.request.fromDate);
          // this.localStorage.StorageSet('toDate', this.vm.request.toDate);
        });
    }
  }

  FilterObject(value, filterObj, except = false) {
    return new FilterPipe().transform(value, filterObj);
  }
  close() {
    this.router.navigateByUrl('/home').then();
  }
  clear() {
    // let tempFromDate: string = this.vm.request.fromDate;
    // let tempToDate: string = this.vm.request.toDate;
    this.vm.report = [];
    this.vm.request = {
      toDate: null,
      fromDate: null,
      company_id: null,
    };
  }

  MathRound(int: number) {
    return Math.round(int);
  }

  parseInt(val) {
    return parseInt(val, 10);
  }

  Print() {
    return window.print();
  }

  setCompanyId(event) {
    this.vm.report = [];
    this.vm.request.company_id = event;
  }

  filterReport() {
    this.vm.report = [];
  }
}
